import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React from 'react';
import { BwjCard } from '../../../../framework/components/bwj-layout';
import { IDoorInstallationOverviewModel } from '../../../../entities-generated/models/project/door-installation-overview-model';
import { CartProductListing, CartProductListingTheme } from '../../../../app-shop/cart/components/cart-pdct-listing';
import { toTitleText } from '../../../../framework/utils/string';
import { DoorType } from '../../../../entities-generated/common/door-type';

interface ICustomerSelectionListingProps {
  door: IDoorInstallationOverviewModel;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: '0.5rem',
    paddingBottom: '0.75rem',
    margin: 0,
    marginBottom: '1rem',
  };

  const handleContainer: IStyle = {
    paddingTop: '0.75rem',
    borderTop: `1px solid ${theme.palette.neutralQuaternary}`,
    marginTop: '0.75rem',
  };

  return mergeStyleSets({
    root,
    handleContainer,
  });
}

export const CustomerSelectionListing: React.FunctionComponent<ICustomerSelectionListingProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { door } = props;

  return (
    <BwjCard className={cs.root}>
      <CartProductListing
        theme={!!door.selectedDoor ? CartProductListingTheme.Primary : CartProductListingTheme.Grayscale}
        label={toTitleText(DoorType[door.doorType])}
        variant={door.selectedDoor?.textureVariant}
        showNotification={false}
        pricing={!!door.selectedDoor ? door.selectedDoorPrice : undefined}
        title={!!door.selectedDoor ? door.selectedDoor.description : 'Awaiting Selection'}
        imageUrl={door.selectedDoor?.textureVariant.productImageUrl}
      />
      {!!door.selectedDoor && door.handleSelectionRequired &&
      <div className={cs.handleContainer}>
        <CartProductListing
          theme={!!door.selectedHandle ? CartProductListingTheme.Secondary : CartProductListingTheme.Grayscale}
          label={'Handle Choice'}
          variant={door.selectedHandle?.textureVariant}
          showNotification={false}
          pricing={undefined}
          title={!!door.selectedHandle ? door.selectedHandle.description : 'Awaiting Selection'}
          imageUrl={door.selectedHandle?.textureVariant.productImageUrl}
        />
      </div>}
    </BwjCard>
  );
};
